// Persistance de la langue côté butineur (Phase 95, I18N-02 / D-09).
//
// C'EST ICI que vit la préférence d'un visiteur sans compte, et nulle part
// ailleurs : le compte n'est qu'une couche de synchro inter-appareils par
// dessus. Une seule clé de stockage portant `{lang, source}`, écrite d'un bloc —
// deux clés séparées laisseraient un état à moitié écrit si l'onglet se ferme
// entre les deux écritures. Le champ `source` est structurel (D-06) : sans
// lui, une valeur simplement tirée du compte passerait pour un clic et
// deviendrait indélogeable par le compte au chargement suivant.
//
// WR-03 (convention de lib/loginCooldown.ts) : ce module POSSÈDE la validation
// de son entrée. `localStorage` est une entrée non fiable — extension, version
// antérieure de l'application, édition manuelle — donc `readStored` re-valide
// tout ce qu'elle lit et rend `null` à la moindre anomalie, c'est-à-dire
// « absent ». Rien de corrompu n'atteint l'état React.
// Refs: phase 95.
import type { Lang } from './types'

/** L'unique clé de stockage de la préférence de langue. */
export const LANG_STORAGE_KEY = 'ss.lang'

/** `explicit` = clic sur le sélecteur ; `account` = valeur tirée du compte. */
export interface StoredLang {
  lang: Lang
  source: 'explicit' | 'account'
}

export function readStored(): StoredLang | null {
  try {
    const raw = window.localStorage.getItem(LANG_STORAGE_KEY)
    if (!raw) return null
    const parsed: unknown = JSON.parse(raw)
    if (typeof parsed !== 'object' || parsed === null) return null
    const { lang, source } = parsed as Partial<StoredLang>
    if (lang !== 'fr' && lang !== 'en') return null
    if (source !== 'explicit' && source !== 'account') return null
    return { lang, source }
  } catch {
    return null // JSON invalide, stockage inaccessible (mode privé strict)
  }
}

export function writeStored(value: StoredLang): void {
  try {
    window.localStorage.setItem(LANG_STORAGE_KEY, JSON.stringify(value))
  } catch {
    // Quota dépassé / Safari privé : la préférence ne survivra pas au
    // rechargement, mais l'application continue de fonctionner.
  }
}

// ponytail: pas de `chosen_at`. Plafond assumé — un appareil dormant peut
// réécraser une préférence plus récente choisie ailleurs. Voie
// d'agrandissement : ajouter `chosen_at` ici ET `profiles.language_updated_at`
// côté base, puis comparer les deux horodatages au lieu de faire gagner
// l'explicite d'office. Le champ local seul ne réparerait rien.
